<template>
	<div class="mydatepicker_wrapper">
		<div>
			<datetime v-on:close="emitvalue"
					input-class="mydatepicker_dep_date_inpt"
					class="mydatepicker_dep_date_inpt"
					v-model="datedep"
					title="Date de départ"
					:format="{ year: 'numeric', month: 'long', day: 'numeric' }"
					value-zone="UTC" zone="UTC"
					:min-datetime="mindatetime"></datetime>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'

export default Vue.extend({
	name: 'smdatepicker',
	components: {Datetime},
	props: ['hotelnum', 'tourop', 'dest'],
	data() {
		return {
			dummy: '',
			// default date, dans 2 semaines
			datedep: new Date(new Date().getTime() + (60 * 24 * 60 * 60 * 1000)).toISOString(),
			// min date, dans 2 jours
			mindatetime: new Date(new Date().getTime() + (2 * 24 * 60 * 60 * 1000)).toISOString()
		}
	},

	mounted() {
		this.init()
	},

	methods: {
		init() {
			this.$emit('changed', this.formatdateforreturn())
		},
		formatdateforreturn() {
			const thedate = new Date(this.datedep)
			// const thedateformatted = (('0' + thedate.getUTCDate()).slice(-2)) + (('0' + thedate.getUTCMonth()).slice(-2)) + thedate.getFullYear()
			const thedateformatted = thedate.getFullYear() + (('0' + (thedate.getUTCMonth() + 1)).slice(-2)) + (('0' + thedate.getUTCDate()).slice(-2))
			return thedateformatted
		},
		emitvalue() {
			this.$emit('changed', this.formatdateforreturn())
		}
	}
})
</script>

<style>
.mydatepicker_wrapper{
	position: relative;
	display: inline-block;
	width: 100%;
	height: 3em;
	background: #fff url(`${process.env.VUE_APP_MVMA_FILES_URL}/mvma/img/calendar_icon.regular.98f9a773.98f9a773.svg`) no-repeat 1em/1em;
}
.mydatepicker_dep_date_inpt input, vdatetime-input{
	background: transparent;
	border: 0;
	color: #35343d;
	font-size: 14px;
	height: 3.43em;
	line-height: 3.43em;
	outline: none;
	padding: 0 1.875em .125em;
	text-align: center;
	width: 90%;
	word-spacing: .3125em;
}
</style>
